import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Grid,
  Row
} from 'react-bootstrap';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './OverlayImageBanner.css';

// Translation
import { FormattedMessage } from 'react-intl';
import messages from '../../../locale/messages';

// History
import history from '../../../core/history';

class OverlayImageBanner extends Component {
  handleClick() {
    history.push('/become-a-host?mode=new');
  }

  render() {
    return (
      <Grid fluid className={s.overlayImageSection}>
        <Row className={s.overmobile}>
          <div className={s.overlayBg}>
            <div className={s.overlayContent}>
              <h2><FormattedMessage {...messages.readyToEarn} /></h2>
              <Button className={s.brnStarted} onClick={this.handleClick} ><FormattedMessage {...messages.readyToEarnDesc} /></Button>
            </div>
          </div>
        </Row>
      </Grid>
    );
  }
}

const mapState = state => ({});

const mapDispatch = {};

export default withStyles(s)(connect(mapState, mapDispatch)(OverlayImageBanner));



// WEBPACK FOOTER //
// src/components/WhyHost/OverlayImageBanner/OverlayImageBanner.js